<template>
  <span>
    <span class="help-btn">
      <a-button
        type="primary"
        @click="showModal"
      >
        Open limited
      </a-button>
      <span class="help">
        <a-tooltip
          placement="top"
          :title="'verification-cdd-form.help-limited-risk-report' | globalize"
        >
          <a-icon type="question-circle" />
        </a-tooltip>
      </span>
    </span>

    <a-modal
      v-model="visible"
      title="Limited risk level report"
      :footer="null"
      :loading="loading">
      <p>Address: <span class="pull-right">{{ riskReport.id }}</span></p>
      <p>Asset: <span class="pull-right">{{ riskReport.assetTypeCode }}</span></p>
      <p>Risk: <span class="pull-right">{{ riskReport.riskMsg }}</span></p>
      <p>Confidence level: <span class="pull-right">{{ riskReport.riskConfidence }}</span></p>
      <p>Level: <span class="pull-right">{{ riskReport.riskLevel }}</span></p>
    </a-modal>
  </span>
</template>

<script>
import AModal from 'ant-design-vue/lib/modal'
import AButton from 'ant-design-vue/lib/button'
import ATooltip from 'ant-design-vue/lib/tooltip'
import AIcon from 'ant-design-vue/lib/icon'

export default {
  name: 'limited-risk-report',
  components: {
    AButton,
    AModal,
    ATooltip,
    AIcon,
  },
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    loadData: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      visible: false,
      riskReport: {},
    }
  },
  methods: {
    async showModal () {
      this.visible = true
      const response = await this.loadData()
      this.riskReport = response.data
    },
    hideModal () {
      this.visible = false
    },
  },
}
</script>

<style lang="scss">
  @import '~ant-design-vue/lib/modal/style/index.css';
  @import '~ant-design-vue/lib/button/style/index.css';
  @import '~ant-design-vue/lib/tooltip/style/index.css';
  @import '~ant-design-vue/lib/icon/style/index.css';
</style>
